<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="609" @click:outside="closeModal">
            <v-card class="custom-card" rounded="0">
              <v-toolbar color="secondary" class="white--text">
                <v-toolbar-title class="font-weight-bold">{{
                  $t("Create a Group")
                }}</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <form autocomplete="off">
                <v-card-text>
                  <v-row class="mt-5">
                    <v-col cols="8">
                      <v-text-field
                        placeholder="Type the group name here"
                        outlined
                        dense
                        required
                        v-model="groupName"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="primary"
                        width="50"
                        depressed
                        @click="addEquipmentGroup"
                        :disabled="!groupName"
                      >
                        ADD
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <label class="title" for="name"
                    >Choose from existing Groups<span class="red--text"
                      >*</span
                    ></label
                  >
                  <v-radio-group v-model="column" column>
                    <v-radio
                      v-for="(item, index) in userEquipmentGroups"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </v-radio>
                  </v-radio-group>
                </v-card-text>
                <v-divider style=""></v-divider>
                <v-card-actions class="mt-10">
                  <v-spacer></v-spacer>
                  <v-btn
                    class=""
                    outlined
                    color="primary"
                    @click="closeModal"
                    width="112"
                  >
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn
                    @click="saveSelection"
                    color="primary"
                    class="btn-11 btn-22"
                  >
                    {{ $t("CONFIRM SELECTION") }}
                  </v-btn>
                </v-card-actions>
              </form>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import { mapGetters } from "vuex";
export default {
  computed: {
    dialog: {
      get() {
        return this.dialogI;
      },
      set() {
        return this.dialogI;
      },
    },
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      groupName: "",
      showRegisterGroup: false,
      column: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    saveSelection() {
      const selection = this.userEquipmentGroups.find(
        item => item.id === this.column
      );
      this.$emit("emitEquipmentGroup", selection);
      this.closeModal();
    },
    addEquipmentGroup() {
      this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($data: CreateEquipmentGroupInput!) {
              createGroupEquipment(createEquipmentGroupInput: $data) {
                id
              }
            }
          `,
          // Parameters
          variables: {
            data: {
              name: this.groupName,
            },
          },
        })
        .then(async res => {
          // console.log(res)
          if (
            res.data.createGroupEquipment &&
            res.data.createGroupEquipment.id
          ) {
            this.groupName = "";
            this.column = res.data.createGroupEquipment.id;
            this.stopLoading();
            this.$apollo.queries.userEquipmentGroups.refetch();
          }
        })
        .catch(async error => {
          console.log(error);
          this.stopLoading();
        });
    },
  },
  apollo: {
    userEquipmentGroups: gql`
      query {
        userEquipmentGroups {
          id
          name
        }
      }
    `,
  },
  props: ["dialogI"],
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped></style>
